import { render } from "./index.vue?vue&type=template&id=039bd37a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=039bd37a&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039bd37a"]])

export default __exports__